import React, { useContext } from 'react';
import { bool, func, string } from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  IconButton,
  LinearProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import InfoRounded from '@mui/icons-material/InfoRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';

// Components
import NavigationButtons from '../navigation-buttons/NavigationButtons';

// Context
import { SubscriptionsContext } from '../../SubscriptionsContext';

// Utils
import * as styles from './SubscriptionHeader.styles';

const SubscriptionHeader = props => {
  const { disabled, handleLeftButtonClick, leftLabel, handleRightButtonClick, rightLabel, title } =
    props;
  const {
    currentStep,
    data: { globalCustomer },
    steps,
  } = useContext(SubscriptionsContext);

  const navigate = useNavigate();
  const { currentAffiliateId, dataCompanyId } = useParams();

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const progress = (currentStep / steps.length) * 100;

  return (
    <>
      {!mdUp && (
        <Box sx={styles.drawerStyle}>
          <Typography sx={styles.header} variant="h5">
            Subscriptions
          </Typography>
          <IconButton
            onClick={() => navigate(`/affiliate/${currentAffiliateId}/${dataCompanyId}/swift-plus`)}
            size="large"
            sx={styles.cancelButton}
          >
            <CloseRounded />
          </IconButton>
        </Box>
      )}
      <Box
        alignItems={mdUp ? 'center' : 'flex-start'}
        display="flex"
        flexDirection="column"
        width="100%"
      >
        <Box sx={styles.headerWrapper}>
          <Box sx={styles.stepperStyles}>
            <LinearProgress
              data-variant="magellanProgressBar"
              value={progress}
              variant="determinate"
            />
            <Typography variant="caption">{`${
              steps?.[currentStep - 1]?.stepLabel
            } (${currentStep} of ${steps?.length})`}</Typography>
          </Box>
          {(mdUp || (!mdUp && currentStep === 3)) && (
            <Box
              component="a"
              href="/downloads/ProgramRules_SwiftPlus_08262021.pdf"
              rel="noopener noreferrer"
              sx={styles.rulesButtonStyles}
              target="_blank"
            >
              <Typography
                sx={{
                  color: 'primary.main',
                  pr: 1,
                }}
                variant="body2"
              >
                Terms
              </Typography>
              <InfoRounded sx={styles.infoIcon} />
            </Box>
          )}
          <Typography
            sx={{
              alignSelf: 'center',
              gridColumnStart: mdUp ? 2 : 'unset',
              gridRowStart: mdUp ? 2 : 'unset',
              padding: theme.spacing(2, mdUp ? 0 : 3),
              textAlign: mdUp ? 'center' : 'left',
            }}
            variant="h5"
          >
            {title}
          </Typography>
          {globalCustomer && mdUp && currentStep !== 3 && (
            <NavigationButtons
              disabled={disabled}
              handleLeftButtonClick={handleLeftButtonClick}
              handleRightButtonClick={handleRightButtonClick}
              leftLabel={leftLabel}
              rightLabel={rightLabel}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

SubscriptionHeader.propTypes = {
  disabled: bool.isRequired,
  handleLeftButtonClick: func.isRequired,
  handleRightButtonClick: func.isRequired,
  leftLabel: string.isRequired,
  rightLabel: string.isRequired,
  title: string.isRequired,
};

export default SubscriptionHeader;
